module.exports = __webpack_public_path__ + "media/images/icons/pair-dbc2f833a0b05ea0fbd671b5172b8501.gif";